import React from 'react'

export const articles = [
  {
  slug: 'bio',
  title: '',
  subtitle: '',
  date: '',
  authors: '',
  body: [{
    type: 'text',
    content: 'Fred Morstatter is a Research Associate Professor in the Thomas Lord Department of Computer Science at the University of Southern California and a Principal Scientist at the USC Information Sciences Institute (ISI). His research develops machine learning and natural language processing methods for responsible AI, with a focus on identifying and mitigating bias in large language models, computational social science, and forecasting.',
  }, {
    type: 'text',
    content: "His group's work spans social media analysis, misinformation, collective intelligence, and the societal impacts of AI, supported by DARPA, ONR, AFOSR, ARPA-H, and the NSF. He received his PhD in Computer Science from Arizona State University in 2017, advised by Huan Liu, and is a co-author of the book Twitter Data Analytics (Springer).",
  }, {
    type: 'text',
    content: (
      <React.Fragment>
        He is also Founder and CEO of{' '}
        <a href="https://commonground.world" target="_blank" rel="noopener noreferrer">CommonGround Labs</a>,
        an AI risk-intelligence startup spun out of his research at USC/ISI.
      </React.Fragment>
    ),
  }],
  }
]
